import React from 'react';

interface MessageBubbleProps {
  content: string;
  isMe: boolean;
  time: string;
  senderName?: string;
}

function formatBubbleTime(iso: string): string {
  if (!iso) return '';
  const d = new Date(iso);
  const now = new Date();
  const isToday = d.getFullYear() === now.getFullYear()
    && d.getMonth() === now.getMonth()
    && d.getDate() === now.getDate();
  const hm = d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  if (isToday) return hm;
  const date = d.toLocaleDateString([], { month: 'short', day: 'numeric' });
  return `${date} ${hm}`;
}

const MessageBubble: React.FC<MessageBubbleProps> = ({ content, isMe, time, senderName }) => (
  <div className={`d-flex ${isMe ? 'justify-content-end' : 'justify-content-start'} mb-3`}>
    <div
      className={isMe ? 'bg-primary text-white' : 'bg-light border'}
      style={{
        maxWidth: '75%',
        borderRadius: '16px',
        padding: '10px 14px',
        wordBreak: 'break-word',
      }}
    >
      {senderName && (
        <div className="fw-bold fs-8 mb-1" style={{ color: '#7239ea' }}>{senderName}</div>
      )}
      <div className="fs-7">{content}</div>
      <div className={`fs-9 mt-1 text-end ${isMe ? 'text-white-50' : 'text-muted'}`}>
        {formatBubbleTime(time)}
      </div>
    </div>
  </div>
);

export default MessageBubble;
